<div class="mt-3" *ngIf="loading">
  <span class="spinner-border spinner-border-sm me-2"></span>
  Cargando vista previa...
</div>

<div class="mt-3 text-muted" *ngIf="!loading && (!products || products.length === 0)">
  Presiona “Previsualizar” para mostrar el reporte aquí.
</div>

<div class="mt-3 table-wrap" *ngIf="!loading && products && products.length">
  <table class="table table-bordered table-sm align-middle sticky-table">

    <thead class="table-light">
      <tr>
        <th class="col-product sticky-left">
          PRODUCTO
        </th>

        <th
          *ngFor="let c of containerCols; trackBy: trackByContainer"
          class="text-end col-container"
          [title]="c.name"
        >
          {{ c.name }}
        </th>

        <th class="text-end col-total">
          TOTAL
        </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let p of products; trackBy: trackByProduct">

        <td class="sticky-left col-product">
          <div class="product-name">{{ p.productName }}</div>
          <div class="product-code">{{ p.productCode }}</div>
        </td>

        <td
          *ngFor="let c of containerCols; trackBy: trackByContainer"
          class="text-end col-container"
        >
          {{ qtyOf(p.productId, c.id) | number:'1.0-4' }}
        </td>

        <td class="text-end col-total fw-semibold">
          {{ totalOf(p) | number:'1.0-4' }}
        </td>
      </tr>
    </tbody>

  </table>
</div>
